import apis from "../../utils/apis";
import {
  setSalaryRangeSkeleton,
  setCitiesRangeSkeleton,
  setSalaryRangeByCities,
  setCitiesList,
} from "../../redux/action/userLocation";
import { retry } from "../../utils/GlobalFunctions";

export async function fetchCountries() {
  return retry(async () => {
    const response = await apis.GET({
      endpoint: "/get-countries-list",
      options: {
        type: "json",
      },
    });
    const selectedCountry = [
      "India",
      "United States",
      "United Kingdom",
      "Canada",
      "Australia",
      "New Zealand",
      "Germany",
    ];
    const responseExperienceRange = await apis.GET({
      endpoint: "/get-experience-range",
      options: {
        type: "json",
      },
    });

    const countryRaw = response.data.countries || [];
    const countries = countryRaw?.filter((item) =>
      selectedCountry.includes(item.name)
    );
    const experienceRange = responseExperienceRange.data.experienceRanges || [];
    return { countries, experienceRange };
  }).catch((error) => {
    console.error("Error fetching countries after retries:", error);
    throw error;
  });
}

export async function fetchStates(country) {
  return retry(async () => {
    const response = await apis.POST({
      endpoint: "/get-state-list",
      payload: { country },
      options: {
        type: "json",
      },
    });
    const states = response.data?.states || [];
    return { states };
  }).catch((error) => {
    console.error("Error fetching states after retries:", error);
    throw error;
  });
}

export async function fetchCities(state, dispatch) {
  return retry(async () => {
    dispatch(setCitiesRangeSkeleton(true));
    const response = await apis.POST({
      endpoint: "/get-cities-list",
      payload: { state },
      options: {
        type: "json",
      },
    });
    dispatch(setCitiesList(response.data.cities));
    dispatch(setCitiesRangeSkeleton(false));
    return response.data.cities;
  }).catch((error) => {
    console.error("Error fetching cities after retries:", error);
    dispatch(setCitiesRangeSkeleton(false));
    throw error;
  });
}
export async function fetchCitiesCountries(state, dispatch) {
  return retry(async () => {
    const response = await apis.POST({
      endpoint: "/get-cities-list",
      payload: { state },
      options: {
        type: "json",
      },
    });
    dispatch(setCitiesList(response.data.cities));

    return response.data.cities;
  }).catch((error) => {
    console.error("Error fetching cities after retries:", error);
    dispatch(setCitiesRangeSkeleton(false));
    throw error;
  });
}

export async function fetchCitiesInstance(state, dispatch) {
  return retry(async () => {    
    const response = await apis.POST({
      endpoint: "/get-cities-list",
      payload: { state },
      options: {
        type: "json",
      },
    });
    dispatch(setCitiesList(response.data.cities));
    return response.data.cities;
  }).catch((error) => {
    console.error("Error fetching cities instance after retries:", error);
    throw error;
  });
}

export async function fetchTopCities(country, state) {
  return retry(async () => {
    const payload = {};
    if (country != null && country !== "") {
      payload.country = country;
    }
    if (state != null && state !== "") {
      payload.state = state;
    }

    if (Object.keys(payload).length === 0) {
      return { cities: [] };
    }

    const response = await apis.POST({
      endpoint: "/get-top-cities-list",
      payload,
    });
    const cities = response.data?.cities ?? [];
    return { cities };
  }).catch((error) => {
    console.error("Error fetching top cities after retries:", error);
    throw error;
  });
}

export async function fetchSalaryRange(
  country,
  state,
  city,
  skillName,
  experienceRange
) {
  return retry(async () => {
    const response = await apis.POST({
      endpoint: "/get-salary-range-by-skill",
      payload: { country, state, city, experienceRange, skillName },
      options: { type: "json" },
    });
    return response.data || [];
  }).catch((error) => {
    console.error("Error fetching salary range after retries:", error);
    throw error;
  });
}
export async function fetchSalaryRangeByCountry(
  country,
  state,
  city,
  skillName,
  experienceRange
) {
  return retry(async () => {    
    const response = await apis.POST({
      endpoint: "/get-salary-range-by-country",
      payload: { country, state, city, experienceRange, skillName },
      options: { type: "json" },
    });
    return response.data || [];
  }).catch((error) => {
    console.error("Error fetching salary range after retries:", error);
    throw error;
  });
}

export async function fetchSalaryRangesForExperiences(
  country,
  state,
  city,
  skillName,
  experienceRange
) {
  const experienceRanges = experienceRange;

  const promises = experienceRanges.map(async ({ label: experienceRange }) => {
    try {
      const data = await fetchSalaryRangeByCountry(
        country,
        state,
        city,
        skillName,
        experienceRange
      );
      return data;
    } catch (error) {
      console.error(
        `Error fetching salary range for experience ${experienceRange}:`,
        error
      );
      return { error };
    }
  });

  return Promise.all(promises);
}

export async function fetchSalaryRangeByCities(
  country,
  state,
  citiesList,
  skillName,
  experienceRange,
  dispatch
) {
  if (!Array.isArray(citiesList)) {
    throw new Error("citiesList must be an array");
  }
  try {
    dispatch(setCitiesRangeSkeleton(true));
    const promises = citiesList.map(async (city) => {
      try {
        const data = await fetchSalaryRange(
          country,
          state,
          city,
          skillName,
          experienceRange
        );
        return data;
      } catch (error) {
        console.error(
          `Error fetching salary range for ${city} after retries:`,
          error
        );
        return { city, error };
      }
    });

    const results = await Promise.all(promises);
    dispatch(setSalaryRangeByCities(results));
    dispatch(setCitiesRangeSkeleton(false));
    dispatch(setSalaryRangeSkeleton(false));

    return results;
  } finally {
    // dispatch(setCitiesRangeSkeleton(false));
  }
}
export async function fetchSalaryRangeByCitiesCountry(
  country,
  state,
  citiesList,
  skillName,
  experienceRange,
  dispatch
) {
  if (!Array.isArray(citiesList)) {
    throw new Error("citiesList must be an array");
  }
  try {
    const promises = citiesList.map(async (city) => {
      try {
        const data = await fetchSalaryRange(
          country,
          state,
          city,
          skillName,
          experienceRange
        );
        return data;
      } catch (error) {
        console.error(
          `Error fetching salary range for ${city} after retries:`,
          error
        );
        return { city, error };
      }
    });

    const results = await Promise.all(promises);
    dispatch(setSalaryRangeByCities(results));
    dispatch(setCitiesRangeSkeleton(false));
    return results;
  } finally {
    // dispatch(setCitiesRangeSkeleton(false));
  }
}
